import React from 'react';

import { AccordionItem } from '@radix-ui/react-accordion';
import { useTranslation } from 'react-i18next';

import { Chip, ChipSize } from '@pkg/components/Sections/Profile/Chip';
import { FilterContent, FilterHeading, type FilterIndex, FilterLink } from '@pkg/components/Sections/Profile/Filters';
import { GROUPS_SEARCH_PARAMS_KEYS, OWNERSHIPS } from '@pkg/hooks';

import { type GroupItemOwnership } from '@app/client/common/structs/groups/groups';

const ITEMS: ReadonlyArray<{ name: GroupItemOwnership; labelI18NextKey: string; to: string }> = OWNERSHIPS.map(
    (item) => ({
        name: item,
        labelI18NextKey: `groups_filter_ownership_${item.toLowerCase()}`,
        to: `?${GROUPS_SEARCH_PARAMS_KEYS.ownership}=${item}`,
    }),
);

// TODO: This component is maintained only until we can update
// the `Groups` filtering to also use `useNftFilter()`.
// Once complete, this file can be removed in favour of `GroupFilterOwnership.tsx`.
export function GroupsFilterOwnership({ value }: FilterIndex) {
    const { t: translate } = useTranslation(['groups']);

    return (
        <AccordionItem value={value}>
            <FilterHeading disableUpperCase>{translate('groups_filter_ownership_title')}</FilterHeading>
            <FilterContent direction="row">
                {ITEMS.map((item) => (
                    <FilterLink key={item.name} to={item.to}>
                        <Chip size={ChipSize.Small}>
                            <Chip.Interior>
                                <Chip.Label content={translate(item.labelI18NextKey)} />
                            </Chip.Interior>
                        </Chip>
                    </FilterLink>
                ))}
            </FilterContent>
        </AccordionItem>
    );
}
